<template>
  <li
    id="self-marriage-certificate"
    v-if="form.certificateOrderProduct.includes('marriageCertificate')"
  >
    <span class="h3">Your marriage or civil partnership details</span>
    <ol class="questions">
      <li>
        <fieldset>
          <legend>
            <span class="label">Place of marriage or civil partnership</span>
          </legend>
          <ol class="questions">
            <li>
              <InputWithError 
                v-model="form.marriageTownCity"
                id="marriageTownCity"
                name="Marriage Town or City"
                label="Town or city"
                maxlength="60"
                size="15"
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.marriageState"
                id="marriageState"
                name="State or territory"
                label="State or territory"
                maxlength="70"
                size="15"
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.dateOfMarriage"
                id="dateOfMarriage"
                name="Date of marriage or civil partnership"
                label="Date of marriage or civil partnership"
                type="date"
                :max="today"
                size="10"
              />
            </li>
            <li>
              <span class="label">Partner 1's name</span>
              <InputWithError 
                v-model="form.p1GivenName"
                id="p1GivenName"
                name="Partner 1 Given Name"
                label="First name"
                maxlength="60"
                size="35"
              />
            </li>
            <li>
              <label for="p1MiddleNames">
                <span class="label">Middle name(s)</span></label
              >
              <input
                id="p1MiddleNames"
                autocomplete="additional-name"
                v-model="form.p1MiddleNames"
                name="Partner 1 Middle Name(s)"
                type="text"
                class="stretchWidth"
                maxlength="255"
              />
            </li>
            
            <li>
              <InputWithError 
                v-model="form.p1FamilyName"
                id="p1FamilyName"
                name="Partner 1 Family Name"
                label="Family name"
                maxlength="60"
                size="35"
                hint="This is the family name before marriage or civil
                partnership."
              />
            </li>
            <li>
              <span class="label">Partner 2's name</span>
              <InputWithError 
                v-model="form.p2GivenName"
                id="p2GivenName"
                name="Partner 2 Given Name"
                label="First name"
                maxlength="60"
                size="35"
              />
            </li>
            <li>
              <label for="p2MiddleNames">
                <span class="label">Middle name(s)</span></label
              >
              <input
                id="p2MiddleNames"
                autocomplete="additional-name"
                v-model="form.p2MiddleNames"
                name="Partner 2 Middle Name(s)"
                type="text"
                class="stretchWidth"
                maxlength="255"
              />
            </li>
            <li>
              <InputWithError 
                v-model="form.p2FamilyName"
                id="p2FamilyName"
                name="Partner 2 Family Name"
                label="Family name"
                maxlength="60"
                size="35"
                hint="This is the family name before marriage or civil
                partnership."
              />
            </li>
          </ol>
        </fieldset>
      </li>
    </ol>
  </li>
</template>

<script>
import InputWithError from '../../InputWithError.vue';

export default {
  props: {
    value: Object,
    today: String,
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  components: {
    InputWithError
  }
};
</script>
